var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c("b-col", { staticClass: "d-flex align-items-center" }, [
                _c("h5", { staticClass: "bold mb-0" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "account.accountPlan.subscriptionsTab.manageTeamSubscriptions"
                        )
                      ) +
                      "\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "d-flex justify-content-end" },
                [
                  _vm.userHasSubscriptions
                    ? _c(
                        "b-button",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            disabled: !_vm.userHasSubscriptions,
                            size: "sm",
                            variant: "danger",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.showManageSubscriptionModal("cancel")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.$tc(
                                  "account.accountPlan.subscriptionsTab.cancelSubscription",
                                  2
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("notification-popover", {
                    attrs: {
                      triggers: _vm.disableAddSubscription ? "hover" : "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "popoverContent",
                        fn: function () {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.addSubscriptionsTooltipText) +
                                "\n          "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "popoverTarget",
                        fn: function () {
                          return [
                            _c(
                              "b-button",
                              {
                                attrs: {
                                  disabled: _vm.disableAddSubscription,
                                  size: "sm",
                                  variant: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.showManageSubscriptionModal(
                                      "add"
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "account.accountPlan.subscriptionsTab.addSubscriptions"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "mt-3 mb-0 d-flex align-items-center" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("account.accountPlan.subscriptionsTab.subtitle")
                  ) +
                  "\n      "
              ),
              _c("icon", {
                directives: [
                  {
                    name: "b-tooltip",
                    rawName: "v-b-tooltip",
                    value: {
                      title: _vm.$t(
                        "account.accountPlan.subscriptionsTab.info"
                      ),
                    },
                    expression:
                      "{\n          title: $t('account.accountPlan.subscriptionsTab.info')\n        }",
                  },
                ],
                staticClass: "ml-1",
                attrs: { name: "info-circle" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-left right-inner-addon mb-4" }, [
        _c(
          "div",
          { staticClass: "right-inner-addon" },
          [
            _c("icon", { attrs: { name: "search" } }),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.search,
                  expression: "search",
                  modifiers: { trim: true },
                },
              ],
              staticClass: "form-control search-inactive-clients",
              attrs: {
                id: "search-for-agents-input",
                type: "search",
                placeholder: _vm.$t("agents.searchFor"),
                autocomplete: "off",
              },
              domProps: { value: _vm.search },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value.trim()
                },
                blur: function ($event) {
                  return _vm.$forceUpdate()
                },
              },
            }),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "d-none",
                attrs: { for: "search-for-agents-input" },
              },
              [_vm._v(_vm._s(_vm.$t("agents.searchFor")))]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("v-client-table", {
        staticClass: "card vue-custom-table no-pagination",
        attrs: {
          data: _vm.filteredSubscriptions,
          options: _vm.options,
          columns: _vm.options.columns,
        },
        scopedSlots: _vm._u([
          {
            key: "agent",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "profile-avatar",
                      _vm._b(
                        { staticClass: "client-avatar d-none d-lg-block" },
                        "profile-avatar",
                        _vm.GET_AGENT(row.username),
                        false
                      )
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "mx-2" }, [
                      _c("span", { staticClass: "bold text-grey" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("fullName")(_vm.GET_AGENT(row.username))
                            ) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      row.isCurrentUser
                        ? _c("span", { staticClass: "font-sm" }, [
                            _vm._v(
                              "\n            (" +
                                _vm._s(_vm.$t("global.words.you")) +
                                ")\n          "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "plan",
            fn: function (ref) {
              var row = ref.row
              return [_vm._v("\n      " + _vm._s(row.plan.name) + "\n    ")]
            },
          },
          {
            key: "willBeRenewed",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm.willBeRenewed(row)
                  ? _c("icon", {
                      attrs: {
                        name: "check-circle",
                        "icon-class": "text-success",
                      },
                    })
                  : _c("icon", {
                      attrs: {
                        name: "minus-circle",
                        "icon-class": "text-light-gray",
                      },
                    }),
              ]
            },
          },
          {
            key: "actions",
            fn: function (ref) {
              var row = ref.row
              return [
                _vm.allowCancel(row)
                  ? _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex flex-column align-items-end justify-content-end",
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "d-lg-inline d-none",
                                attrs: { variant: "danger", size: "sm" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleShowCancelModal(
                                      row.username,
                                      row.givenName
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$tc(
                                        "account.accountPlan.subscriptionsTab.cancelSubscription",
                                        1
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "d-lg-none",
                                attrs: {
                                  variant: "transparent",
                                  "toggle-class": "text-gray position-static",
                                  "no-caret": "",
                                  right: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "button-content",
                                      fn: function () {
                                        return [
                                          _c(
                                            "i",
                                            { staticClass: "material-icons" },
                                            [_vm._v("more_vert")]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    staticClass: "text-center",
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleShowCancelModal(
                                          row.username
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$tc(
                                            "account.accountPlan.subscriptionsTab.cancelSubscription",
                                            1
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("manage-subscriptions-modal", {
        ref: "manageSubscriptionModal",
        attrs: { mode: _vm.currentMode },
      }),
      _vm._v(" "),
      _c("cancel-plan-confirmation", {
        attrs: {
          show: _vm.showCancelModal,
          loading: _vm.canceling,
          "agent-name": _vm.subscriptionToCancel.agentName,
          "number-of-agents": 0,
        },
        on: {
          "update:show": function ($event) {
            _vm.showCancelModal = $event
          },
          "cancel-plan": _vm.cancelSingleSubscription,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }